export function HeroIllustration({ type, site }: { type: 'CV' | 'LM'; site: any }) {
  const image =
    type === 'CV'
      ? `https://mmc-preview-s3-storage.s3.eu-central-1.amazonaws.com/templates/resumes/${site?.html_lang}/castor.jpeg`
      : `https://mmc-preview-s3-storage.s3.eu-central-1.amazonaws.com/templates/letters/${site?.html_lang}/castor.jpeg`;
  const imageAlt = type === 'CV' ? 'CV' : 'LM';

  return (
    <div className="relative z-[1] mb-8 lg:mb-0 lg:w-1/2">
      <div className="relative w-full scale-95 lg:scale-90">
        {/* Image de fond */}
        <img src="/images/home/hero/hero-bg.webp" alt="hero" width={380} height={433} className="h-auto w-[70%]" />

        {/* CV/LM image  */}
        <div className="absolute right-[12%] top-[14%] w-[55%] origin-top-left rotate-2">
          <img
            src={image}
            alt={imageAlt}
            className="w-full rounded-lg border border-[#ECF1FD]"
            width={325}
            height={466}
            loading="lazy"
          />

          {/* Bouton IA */}
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 scale-75 sm:scale-100">
            <div className="inline-flex min-h-[45px] min-w-[156px] items-center justify-center gap-2 overflow-hidden rounded-3xl border-[4.5px] border-[#8184F6] bg-[#0E2053] px-3 py-2 shadow-[0_0_0_4.5px_rgba(129,132,246,0.25)]">
              <div className="relative h-[21px] w-[22px]">
                <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.45323 3.1595L9.01022 4.48889C10.0833 7.05002 12.0357 9.14375 14.5158 10.3929L15.803 11.0412L14.4737 11.5982C11.9125 12.6713 9.81881 14.6237 8.5697 17.1037L7.92133 18.391L7.36435 17.0617C6.29128 14.5005 4.33885 12.4068 1.8588 11.1577L0.571515 10.5093L1.9009 9.95233C4.46203 8.87927 6.55576 6.92684 7.80487 4.44679L8.45323 3.1595Z"
                    fill="white"
                  />
                  <path
                    d="M16.9352 13.0871C17.7646 15.0665 19.2736 16.6848 21.1903 17.6502C19.2109 18.4795 17.5927 19.9885 16.6273 21.9053C15.7979 19.9259 14.2889 18.3077 12.3721 17.3422C14.3516 16.5129 15.9698 15.0039 16.9352 13.0871Z"
                    fill="white"
                  />
                  <path
                    d="M4.31729 0.489478C4.62094 1.21421 5.17343 1.80668 5.87521 2.16014C5.15048 2.46379 4.55801 3.01627 4.20455 3.71806C3.9009 2.99333 3.34841 2.40086 2.64663 2.0474C3.37136 1.74375 3.96383 1.19126 4.31729 0.489478Z"
                    fill="white"
                  />
                  <path
                    d="M21.4173 11.5793C21.7209 12.3041 22.2734 12.8965 22.9752 13.25C22.2505 13.5536 21.658 14.1061 21.3045 14.8079C21.0009 14.0832 20.4484 13.4907 19.7466 13.1372C20.4713 12.8336 21.0638 12.2811 21.4173 11.5793Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="whitespace-nowrap text-xs font-medium text-white">{site?.hero?.generate_with_ai}</div>
            </div>
          </div>

          {/* Contenu pré-rédigé */}
          <div className="absolute -right-14 top-1/3 w-[170px] scale-75 sm:scale-100">
            <div className="flex w-[165px] flex-col gap-2 rounded-lg border border-[#E6EAF2] bg-white p-2">
              <div className="text-[10px] font-medium leading-[14px] text-black">{site?.hero?.pre_written_content}</div>
              <div className="flex items-center gap-2 rounded-lg border border-[#7EDD76] p-2">
                <div className="flex h-4 w-4 items-center justify-center rounded-full bg-[#7EDD76]">
                  <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.1366 7.31201L5.06558 9.38059L10.237 4.55814"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="h-[7px] w-[110px] rounded-full bg-[#ECF1FD]" />
              </div>
            </div>
          </div>

          {/* Importer mon CV */}
          {type === 'CV' && (
            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 scale-75 sm:scale-100">
              <div className="inline-flex h-[35px] min-w-[145px] items-center justify-center gap-3 rounded-[8px] border border-[#4B4FF2] bg-[#ECF1FD] px-4 py-2">
                <div className="flex-shrink-0">
                  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17.937 13.7549L17.8207 17.0862C17.8053 17.528 17.615 17.9455 17.2917 18.247C16.9684 18.5485 16.5386 18.7092 16.0969 18.6937L4.43732 18.2866C3.99556 18.2711 3.57803 18.0809 3.27656 17.7576C2.9751 17.4343 2.81441 17.0045 2.82984 16.5627L2.94617 13.2314"
                      stroke="#4B4FF2"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.8093 7.80896L10.7906 3.49942L6.48105 7.51813"
                      stroke="#4B4FF2"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.7906 3.49951L10.4416 13.4934"
                      stroke="#4B4FF2"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span className="whitespace-nowrap text-[10px] font-medium leading-[14px] text-[#0E2053]">
                  {site?.hero?.import_cv}
                </span>
              </div>
            </div>
          )}

          {/* Color picker */}
          <img
            src="/images/home/hero/color-picker.svg"
            alt="color-picker"
            className="absolute -left-16 top-1/3 size-32 scale-75 sm:scale-100"
          />
        </div>
      </div>
    </div>
  );
}
